const translationUz ={
  navTel: "Ishonch telefoni",
  email: "Elektron pochta",
  home:"Bosh sahifa",

  logo1: "Tibbiyot xodimlarining kasbiy",
  logo2: "malakasini rivojlantirish markazi",
  logo3: "1 - ultratovush diagnostikasi kafedrasi",
  
  kafedra: "Kafedra",
  kafedra1: "Tarix",
  kafedra2: "Professor-o’qituvchilar",
  kafedra3: "Professor-o'qituvchilar portfoliosi",
  kafedra4: "Ma’lumotnomalar",
  kafedra5: "Professor-o’qituvchilarning ilmiy nashirlari",

  xujjatlar: "Me'yoriy hujjatlar",
  xujjatlar1: "Prezident farmonlari",
  xujjatlar2: "Sog’liqni saqlash vazirligi buyruqlari",
  xujjatlar3: "Markaz buyruqlari",
  xujjatlar4: "Dasturlar",
  xujjatlar5: "Ishchi dasturlar",
  xujjatlar6: "Taqvim reja",
  xujjatlar7: "Dars jadvali",

  faoliyat: "Faoliyat",
  faoliyat1: "O’quv faoliyati",
  faoliyat2: "Ilmiy faoliyat",
  faoliyat3: "Uslubiy tashkiliy faoliyat",
  faoliyat4: "Kundalik faoliyat",


  tinglovchilar: "Tinglovchilar",
  tinglovchilar1: "Tinglovchilar uchun ma’lumotlar",
  tinglovchilar2: "Video ma’ruzalar",

  news: "Yangiliklar",
  news1: "E’lonlar",
  news2: "Konferensiyalar",

  contact:"Aloqa",

  carsuelTittle: "1 - ultratovush diagnostikasi kafedrasi",

  resultsTittle: "Uzluksiz ta'lim orqali millat salomatligi sari",
  resultsCardbody1: " yillik shifokorlar ta'limining tarixi",
  resultsCardbody2: "viloyat filiallari",
  resultsCardbody3: "ilmiy darajali xodimlar",
  resultsCardbody4: "yuqori texnologiyali simulatsiya markazlari",
  resultsCardbody5: "fakultetlar",
  resultsCardbody6: "akademik",
  resultsCardbody7: "ilmiy maktablar",
  resultsCardbody8: "kafedra ilg'or klinika va markazlarda",
  resultsCardbody9: "fan nomzodi va doktorlari",

  sitetittle: "Foydali havolalar",

  footerTittle: "Ijtimoiy tarmoqlar:",
  footer1: "Manzil:",
  footer2: "Aviasozlar ko'chasi 29, Yashnobod tumani, Toshkent",
  footer3: "Ish vaqti:",
  footer4: "Ish tartibi:",
  footer5: "Dushanba - Juma, 8:30 - 14:30",
  footer6: "Dam olish kunlari:",
  footer7: "Shanba, Yakshanba",


  tarixTittle: "Tarix",
  tarix1: "Abdufattev Ulug'bek Avazjanovich",
  tarix2: "Yuklab olish",
  tarix3: "Alimov Rustam Raximovich",
  tarix4: "Yuklab olish",
  tarix5: "Jo'raev Zoxidjon Abdujalilovich",
  tarix6: "Yuklab olish",
  tarix7: "Zaxidova Nodira Axmadovna",
  tarix8: "Yuklab olish",
  tarix9: "Isroilova Mahpuza Xalilovna",
  tarix10: "Yuklab olish",
  tarix11: "Qodirov, Nodirbek Abdukaxarovich",
  tarix12: "Yuklab olish",
  tarix13: "Qurbonov Furqat Turdiyevich",
  tarix14: "Yuklab olish",
  tarix15: "Qurbonova Vusala Vidadievna",
  tarix16: "Yuklab olish",
  tarix17: "Rozixodjayeva Gulnora Axmedovna",
  tarix18: "Yuklab olish",
  tarix19: "Xasanov Izzatilla G'aybilloyevich",
  tarix20: "Yuklab olish",
  tarix21: "Xo'jaqulov Odiljon Alisherovich",
  tarix22: "Yuklab olish",
  tarix23: "Ikramova Zulfiya To'lqinovna",
  tarix24: "Yuklab olish",
  tarix25: "Ikramova Zulfiya To'lqinovna",
  tarix26: "Yuklab olish",
  tarix27: "Normuradova Nodira Muradullayevna",
  tarix28: "Yuklab olish",
  tarix29: "Rasulova Munisa Mirmislimovna",
  tarix30: "Yuklab olish",
  tarix31: "Fazilov Akram",
  tarix32: "Yuklab olish",
  tarix33: "Miryusupov Mirqosim Mirsamatovich",
  tarix34: "Yuklab olish",
  tarix35: "Niyazov Aziz Nabiyevich",
  tarix36: "Yuklab olish",
  tarix37: "Sipova Go'zaloy G'ulomidinovna",
  tarix38: "Yuklab olish",


  darsTittle: "Dars jadvali",
  darsopen: "Ochish",
  darssave: "Saqlash",
  dars1: "Tugʻma nuqsonlarning prenatal ultratovush diagnostikasi",
  dars2: "KLINIK ULTRATOVUSh DIAGNOSTIKASI",
  dars3: "Akusherlik amaliyotida dopplerografiya texnologiyalari",
  dars4: "Klinik neyrosonografiya",
  dars5: "Ultratovush mammografiyasining innovasion texnologiyalari",

  prezidentTittle: "Prezident farmonlari",

  ssvTittle: "Sog'liqni saqlash vazirligi buyruqlari",

  markazTittle: "Markaz buyruqlari",


  dasturTittle: "Dasturlar",
  dastur1: "Fetal exokardiografiya asoslari",
  dastur2: "Ultratovush mammografiyasida BI-RADS tasniflanishining klinik qo'llanilishi",
  dastur3: "Bachadon miomasining ultratovush diagnostikasi",
  dastur4: "Tuxumdonlar hosilalarini tashxizlashda O-RADS tasniflanishining klinik qo' llanilishi",
  dastur5: "Urgent holatdagi bemorlarda FAST, BLUE, RUSH ultratovush tekshirish protokollarining qo'llanilishi",
  dastur6: "Klinik neyrosonografiya",
  dastur7: "Flebologiyada ultratovush diagnostikasi zamonaviy texnologiyalari<",
  dastur8: "Ultratovush diagnostikasi apparatlarini boshqarish tamoyillari va exografik tasvirni maqbullashtirish",
  dastur9: "Akusherlik amaliyotida dopplerografiya texnologiyalari",
  dastur10: "Fetal exokardiografiya: tugoma yurak nuqsonlar diagnostikasi",
  dastur11: "Ultratovush mammografiyasining innovatsion texnologiyalari",
  dastur12: "Klinik amaliyotda ultratovush elastografiya texnologiyalari",
  dastur13: "Tug'ma nuqsonlarning prenatal ultratovush diagnostikasi",
  dastur14: "Qon-tomir tizimini kompleks ultratovush diagnostikasi",
  dastur15: "Akusherlik amaliyotida ultratovush diagnostikasiningtanlangan masalalari",
  dastur16: "Siydik tosh kasalligi va uning asoratlarini ultratovush diagnostikasi va davolash usullari",
  dastur17: "Urologiya amaliyotida ultratovush diagnostikasining tanlangan masalalari",
  dastur18: "Akusherlik amaliyotida ultratovush diagnostikasi asoslari",

  
  contactTittle: "Biz bilan bog'lanish",
  contact1: "Manzil:",
  contact2: "Toshkent shahar. M.Ulug’bek tumani. Parkent ko’chasi 51",
  contact3: "Aloqa raqami:",
  contact4: "Email:",
  contact5: "Ish tartibi:",
  contact6: "Vebsayt:",
  contact7: "Tushlik:",


  workingPrograms1: "Ultratovush diagnostikasi apparatlarini boshqarish tamoyillari",
  workingPrograms2: "Ultratovush mammografiyasining innovatsion texnologiyalari",
  workingPrograms3: "Flebologiyada ultratovush diagnostikasi zamonaviy texnologiyalari",
  workingPrograms4: "Qon tomir tizimini kompleks ultratovush diagnostikasi klinikasi",
  workingPrograms5: "Tug‘ma nuqsonlarning prenatal ultratovush diagnostikasi",
  workingPrograms6: "Urologiya amaliyotida ultratovush diagnostikasining tanlangan usullari",
  workingPrograms7: "Klinik ultratovush diagnostikasi",
  workingPrograms8: "Bachadon miomasini ultratovush diagnostikasi",
  workingPrograms9: "Tuxumdon hosilalarini tashxislashda O RADS tasnifi",
  workingPrograms10: "Ultratovush mammografiyasida BI RADS UZD",
  workingPrograms11: "Urgent holatdagi bemorlarda FAST, BLUE, RUSH ultratovush tekshiruvi",
  workingPrograms12: "Fetal exokardiografiya asoslari UZD",
  workingPrograms13: "Akusherlik amaliyotida dopplerografiya texnologiyalari UZD",
  workingPrograms14: "Klinik neyrosonografiya UZD",
  workingPrograms15: "Klinik ultratovush tashxislashda elastografiya texnologiyalari",

  siteLink1: "O'zbekiston Respublikasi Sog'liqni saqlash vazirligi",
  siteLink2: "O'zbekiston Respublikasi Prezidenti veb-sayti",
  siteLink3: "Yagona interaktiv davlat xizmatlari portali",

  test: "Ma'lumotlar to'liq yuklanmagani sababli sayt test rejimda ishlayapdi",



}

export default translationUz